module.exports = __webpack_public_path__ + "img/anchor.b9e1b6d3.svg";